WiseMetering.Views.EditIndicatorMetal = WiseMetering.Views.Modal.Save.extend({
    form_prefix: 'indicator_metal',
    template: 'templates/indicators/edit_metal',
    title: () => i18next.t('modal.title.indicators.edit_metal'),
    width: 400,

    save: function() {
        const
            value = parseFloat(this.$('input#metal_value').val()),
            timestamp = parseInt(this.options.timestamp);

        this.model
            .editMetal({ timestamp, value })
            .then(function() {
                this.options.target.trigger('customEdit', { value });
                this.modal.close();
            }.bind(this));
    },

    serializeData: function() {
        return {
            timestamp: this.options.timestamp,
            unit: this.model.get('unit'),
            value: this.options.value
        };
    }
});
